import Cart from "cart-store";

if (!window.__dbCartExperienceLoaded) {
  window.__dbCartExperienceLoaded = true;

  const refreshAddons = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;

    document.querySelectorAll("[data-db-cart-addon]").forEach((addon) => {
      const variantId = Number(addon.dataset.variantId);
      const alreadyInCart = cart.items.some((item) => Number(item.variant_id) === variantId);
      addon.hidden = alreadyInCart;
    });
  };

  const refreshAfterRender = (cart) => {
    window.requestAnimationFrame(() => refreshAddons(cart));
  };

  refreshAfterRender(Cart.getState().cart);
  Cart.subscribe((state) => refreshAfterRender(state.cart));
  document.addEventListener("on:cart:loaded", (event) => refreshAfterRender(event.detail.cart));
}
